import styled from "styled-components";

export const HeaderTwoCont = styled.section`
  .citiesDropDown {
    width:auto;
    .dropDownWrapper{width:auto}
    input {
      min-width: 50px;
    }
  }

  & .addPostLink {
    padding: 9px 20px;
  }

  & .bubbleLink {
    padding: 8px 16px 0;
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  button {font-size: 1em}
  }
`;

export const RedBubble = styled.span`
  top: -13px;
  right: 0;
  height: 25px;
  width: 25px;
  background-color: #f45353;
  line-height: 27px;
`;
